const SAFE_HREF_PATTERN = /^https?:\/\//i

// 属性名 → 「その値を残してよいか」の判定。未登録の属性は無条件除去
// (style はここに書かず default: false のフォールバックに任せる)。
// 対象属性を増やすときはここに追記するだけでよい。属性名は DOM
// シリアライズで必ず小文字化されるため、小文字リテラルで判定できる。
const ATTR_ALLOW: Partial<Record<string, (value: string) => boolean>> = {
  href: (value) => SAFE_HREF_PATTERN.test(value),
}
const SANITIZED_ATTRS = ['href', 'style']

/**
 * Strips non-http(s) link schemes (`javascript:` etc.) and any `style`
 * attribute from HTML before it reaches a request WAF's XSS body rule
 * inspects. Both are known triggers for that rule, so this must run before
 * the HTML is embedded in any request body.
 *
 * @param html - HTML string to sanitize before sending.
 * @returns The same HTML with unsafe hrefs and all style attributes removed.
 */
export function sanitizeUnsafeContent(html: string): string {
  // 呼び出し元によっては入力のたびに呼ばれる。対象属性が1つも無ければ
  // DOMParser のパース自体を丸ごとスキップできる。
  if (!SANITIZED_ATTRS.some((attr) => html.includes(`${attr}=`))) {
    return html
  }

  const doc = new DOMParser().parseFromString(html, 'text/html')

  SANITIZED_ATTRS.forEach((attr) => {
    const isAllowed = ATTR_ALLOW[attr] ?? (() => false)
    doc.querySelectorAll<HTMLElement>(`[${attr}]`).forEach((el) => {
      if (!isAllowed(el.getAttribute(attr) ?? '')) {
        el.removeAttribute(attr)
      }
    })
  })

  return doc.body.innerHTML
}
